export default __webpack_public_path__ + "static/media/Rip Space.933563d4.png";